import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import FeaturedBlog from "./sections/FeaturedBlog";
import FreeFranceDirectoryPreview from "./sections/FreeFranceDirectoryPreview";
import DigitalShopPromotion from "./sections/DigitalShopPromotion";
import ComparisonToolsTeaser from "./sections/ComparisonToolsTeaser";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <Hero />
      <FeaturedBlog />
      <FreeFranceDirectoryPreview />
      <DigitalShopPromotion />
      <ComparisonToolsTeaser />
      <Footer />
    </div>;
}